export { default, type TInputLikeProps } from "./InputLike";
